// extracted by mini-css-extract-plugin
module.exports = {"imgTextK":"ImgTextK_imgTextK__iXy7z"};